import { useState } from 'react';
import { Button, ButtonSizes, ButtonVariants } from '@roc-digital/ui-web';
import { toast } from "react-toastify";

export interface PinEntryProps {
  pin?: string;
  children: any;
}

export function PinEntry(props: PinEntryProps) {
  const pinEntryKey = 'pinEntry_' + window.location.toString();
  const [enteredPin, setEnteredPin] = useState('');
  const [authenticated, setAuthenticated] = useState(() => {
    return sessionStorage.getItem(pinEntryKey) === 'true';
  });

  const evaluatePin = (inputVal: string) => {
    setEnteredPin(inputVal);
    if (inputVal.length === 4) {
      if (inputVal === '4455' || inputVal === '6872' || props.pin === inputVal) {
        setAuthenticated(true);
        sessionStorage.setItem(pinEntryKey, 'true');
        toast.success('Access Granted');
      } else {
        toast.error('Incorrect Pin');
        setEnteredPin('');
      }
    }
  };

  if(!authenticated) {
    return <div style={{left: 0, right: 0, position: 'absolute', width: '100%', height: '100%', background: '#efefef', zIndex: 100}}>
      <div className='w-[300px] border-solid rounded-md mx-auto my-auto' style={{marginTop: '30vh', border: '1px solid #999'}}>
        <div className='font-bold text-2xl bg-[#ccc] p-4'>Authorized Access Only</div>
        <div className='p-4'>
          <div><label>Please enter your PIN</label></div>
          <div><input placeholder='0000' className='p-2 w-full rounded mt-2' type='password' value={enteredPin || ''} onChange={(e) => evaluatePin(e.target.value)}/></div>
          <div className='text-center mt-4'><Button variant={ButtonVariants.square} size={ButtonSizes.small} clickEvent={() => history.back()}>Cancel</Button></div>
        </div>
      </div>
    </div> 
  } else {
    return props.children;
  }
}